import { requestPermissionsAsync } from 'expo-contacts';
import { useCallback, useState } from 'react';
import { PermissionsAndroid } from 'react-native';
import { isAndroid, isIOS } from 'shared/constants/platform';

type PermissionStatus = 'granted' | 'denied' | 'undetermined' | 'error' | null;

const useRequestContactPermission = (): {
  permissionStatus: PermissionStatus;
  requestPermission: () => Promise<PermissionStatus>;
} => {
  const [permissionStatus, setPermissionStatus] =
    useState<PermissionStatus>(null);

  const requestPermission = useCallback(async (): Promise<PermissionStatus> => {
    try {
      let status;
      if (isIOS) {
        const { status: _status } = await requestPermissionsAsync();
        status = _status;
      } else if (isAndroid) {
        status = await PermissionsAndroid.requestMultiple([
          PermissionsAndroid.PERMISSIONS.READ_CONTACTS,
          PermissionsAndroid.PERMISSIONS.WRITE_CONTACTS,
        ]);
      }
      setPermissionStatus(status as PermissionStatus);
      return status as PermissionStatus;
    } catch {
      setPermissionStatus('error');
      return 'error';
    }
  }, []);

  return { permissionStatus, requestPermission };
};

export default useRequestContactPermission;
